import store from '@/store'

const SUCCESS_CODE = 100;
const LOADING_CONFIG = {
    lock: true,
    text: '正在加载...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
};
const NOTIFICATION_CONFIG = {
    duration: 0,
    position: 'bottom-right'
};

/**
 * @param {Object} options 请求参数
 * @param {string} options.url 请求地址
 * @param {Object} options.data 请求体数据
 * @param {Object} options.params 查询参数
 * @param {string} options.method 请求方法
 * @param {Object} options.that Vue实例
 * @param {boolean} options.load 是否显示加载动画
 * @param {string} options.responseType 响应类型（如 'blob'）
 * @param {Function} options.onUploadProgress 上传进度回调
 * @param {boolean} options.isFileRequest 是否为文件请求
 * @param {boolean} options.showSuccessNotification 是否显示成功通知
 * @param {boolean} options.returnRawResponse 是否返回原始响应
 * @returns {Promise} Promise对象
 */
export async function request({ url, data = {}, params = {}, method = 'post', that, load = false, responseType, onUploadProgress, isFileRequest = false, showSuccessNotification = true, returnRawResponse = false }) {
    const companyId = store.getters.getCompanyId
    const requestUrl = companyId + url
    const token = sessionStorage.getItem('token');
    const headers = { token };
    let loading = null;

    if (load && that && that.$loading) {
        loading = that.$loading(LOADING_CONFIG);
    }

    try {
        let response;
        const requestConfig = { headers, params };

        if (responseType) {
            requestConfig.responseType = responseType;
        }

        if (onUploadProgress) {
            requestConfig.onUploadProgress = onUploadProgress;
        }

        if (method.toLowerCase() === 'get') {
            response = await that.$http.get(requestUrl, requestConfig);
        } else {
            response = await that.$http[method](requestUrl, data, requestConfig);
        }

        if (loading) {
            loading.close();
        }

        if (isFileRequest) {
            return response.data;
        }

        if (response.data.code === SUCCESS_CODE) {
            if (returnRawResponse) {
                return response;
            }
            if (response.data.data !== undefined) {
                return response.data.data;
            } else {
                if (showSuccessNotification && that && that.$notify) {
                    that.$notify.success({
                        title: '成功',
                        message: response.data.msg || '操作成功',
                        ...NOTIFICATION_CONFIG
                    });
                }
                return Promise.resolve();
            }
        } else {
            throw { isBusinessError: true, message: response.data.msg };
        }
    } catch (error) {
        if (loading) {
            loading.close();
        }
        if (!isFileRequest) {
            handleError(error, that);
        }
        return Promise.reject(error);
    }
}

/**
 * 统一错误处理
 * @param {Error} error 错误对象
 * @param {Object} that Vue实例
 */
function handleError(error, that) {
    if (!that || !that.$notify) return;

    if (error && error.isBusinessError) {
        that.$notify.error({
            title: '操作失败',
            message: error.message || '未知错误',
            ...NOTIFICATION_CONFIG
        });
    } else {
        that.$notify.error({
            title: '请求失败',
            message: error.message || '服务器接口处理异常',
            ...NOTIFICATION_CONFIG
        });
    }
}